import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import { isValidEmail } from "../../helpers/data";
import Email from "../common/input/Email";
import PhoneNumber from "../common/input/PhoneNumber";
import MiniSpinner from "../common/MiniSpinner";


class ShareVideoVisitModal extends React.Component {
    constructor(props) {
        super(props);
        const { patientExternalId } = props.appointment;
        props.getPatientDemographics(patientExternalId, this.getPatientDemographicsCallback);
        this.state = {
            loadingDemographics: true,
            sendingSms: false,
            contactNumber: '',
            number: '',//patientMobileNumber ? patientMobileNumber.replace(/-/g,'.') : '',
            email: '',//patientEmailAddress,
            isMobileNumberValid: false,//isValidPhoneNumber(patientMobileNumber),
            isEmailValid: false,//isValidEmail(patientEmailAddress)
            numberList: [],
            currentTime: '',
            showSmsMessage: true,
            showEmailMessage: true,
        };
    }

    componentDidMount() {
        this.smsSent = this.emailSent = false;
        logUI("UI.ShareVideoVisitModal.ComponentDidMount", new Date(), Tools.getURLPath());
        if (this.props.showModal) {
            logUI("UI.ShareVideoVisitModal.Displayed", new Date(), Tools.getURLPath());
        }
    }

    getPatientDemographicsCallback = (response, error) => {
        let numberList = [];
        let email = '';
        if (response) {
            email = response.email;
            if (response.phones) {
                for (let i = 0; i < response.phones.length; i++) {
                    const phoneType = response.phones[i].type
                    numberList.push({ number: response.phones[i].number.replace(/-/g, '.'), type: phoneType })
                }
            }
            this.setState({
                loadingDemographics: false,
                // mobileNumber: mobileNumber ? mobileNumber.replace(/-/g, '.') : '',
                numberList: numberList,
                email: email,
                isEmailValid: isValidEmail(email)
            });
        }
        else {
            this.setState({ loadingDemographics: false });
        }
    }

    smsVideoVisitLink = (number, type) => {
        const currentTime = Tools.dateStringFormat(new Date(), "h:mm A")
        this.setState({ contactNumber: number, currentTime, showSmsMessage: true, showEmailMessage: false, sendingSms: type && true })
        logUI("UI.ShareVideoVisitModal.SMS", new Date(), Tools.getURLPath(), number);
        this.props.sendSms(this.props.appointment.csnId, number, this.props.appointment.patientName, () => {
            if (this.props.smsVideoVisitLink) { this.setToasterMsg(number, this.props.smsVideoVisitLink.isSuccess); }
            this.props.getShareLinkHistory(this.props.appointment.csnId);
        });
        this.smsSent = true;
    }

    emailVideoVisitLink = () => {
        const currentTime = Tools.dateStringFormat(new Date(), "h:mm A")
        this.setState({ currentTime, showEmailMessage: true, showSmsMessage: false })
        logUI("UI.ShareVideoVisitModal.Email", new Date(), Tools.getURLPath(), this.state.email);
        this.props.sendEmail(this.props.appointment.csnId, this.state.email, this.props.appointment.patientName, () => {
            if (this.props.emailVideoVisitLink) { this.setToasterMsg(this.state.email, this.props.emailVideoVisitLink.isSuccess);  }
            this.props.getShareLinkHistory(this.props.appointment.csnId);
        });
        this.emailSent = true;
    }

    setToasterMsg(target, isSuccess) {
        const currentTime = Tools.dateStringFormat(new Date(), "h:mm A");
        let message = target ? `Link sent to ${target} at ${currentTime}` : `Link sent at ${currentTime}`;
        if (isSuccess) {
            this.props.setVideoVisitToastrMsg(message, true);
        }
        else {
            message = target ? `Link failed to ${target} at ${currentTime}` : `Link failed at ${currentTime}`;
            this.props.setVideoVisitToastrMsg(message, false);
        }
        this.closeModal();
    }

    closeModal = () => {
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
        logUI("UI.ShareVideoVisitModal.Closed", new Date(), Tools.getURLPath());
    }

    render() {
        const { loadingDemographics, contactNumber, email, isMobileNumberValid, isEmailValid, sendingSms, number, numberList, currentTime, showEmailMessage, showSmsMessage } = this.state;
        const { showModal, smsVideoVisitLink, emailVideoVisitLink, appointment } = this.props;
        return (
            <div>
                <Modal className="shared-link-modal" isOpen={showModal} centered toggle={this.closeModal}>
                    <ModalHeader toggle={this.closeModal} />
                    <ModalBody>
                        <div className="row">
                            <div className="col-12">
                                <h3 className="shared-link-modal__header">How would you like to send the link to the visit?</h3>
                                <div className="patient-icon-append">
                                    <span className="svg-patient patient-icon" />
                                    <h4>{appointment.patientName} <span className="line" /> {appointment.apptTime}</h4>
                                </div>
                            </div>
                            <div className="col-12 shared-link-modal__form">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="shared-link-modal__section">
                                            <div className="row no-gutters shared-link-group">
                                                <div className="col shared-link-group__icon">
                                                    <span className="svg-text-vv" />
                                                </div>
                                                <div className="col shared-link-group__content">
                                                    {numberList.length > 0 &&
                                                        <React.Fragment>{numberList.map((item, index) => (
                                                            <div className="row no-gutters align-items-center shared-link-option" key={index + 1}>
                                                                <div className="col shared-link-option__info">
                                                                    <div className="shared-link-phone-list truncate">
                                                                        <div className="shared-link-phone-list__text">{item.number}{" "}</div>
                                                                        <div className="shared-link-phone-list__type">{item.type}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="col shared-link-option__btn">
                                                                    <button type="button" className="btn text-btn" onClick={() => this.smsVideoVisitLink(item.number)}>
                                                                        <span className="send__btn-text">SEND</span>
                                                                    </button>
                                                                </div>
                                                                <div className="col-12 divider"></div>
                                                            </div>
                                                        ))}</React.Fragment>
                                                    }
                                                    <div className="row no-gutters align-items-center shared-link-option">
                                                        <div className="col shared-link-option__field">
                                                            <PhoneNumber placeholder="Mobile Phone Number" value={number} name="mobileNumber" autoComplete="off" showClearBtn validateOnMount required={false}
                                                                onChange={(e, isMobileNumberValid) => this.setState({ number: e.target.value, isMobileNumberValid, showSmsMessage: false })} />
                                                        </div>
                                                        <div className="col shared-link-option__btn">
                                                            <button type="button" className="btn text-btn" onClick={() => this.smsVideoVisitLink(number, "text")}
                                                                disabled={!number || (!isMobileNumberValid) || (smsVideoVisitLink && smsVideoVisitLink.isWaiting)}
                                                            >SEND</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {this.smsSent && smsVideoVisitLink &&
                                                <div className="row">
                                                    <div className="col-12">
                                                        {showSmsMessage && smsVideoVisitLink.isSuccess &&
                                                            <div className="success-msg">
                                                                <span className="icon-list-check" />{" "}
                                                                        Link sent to {contactNumber || number} at {currentTime}
                                                            </div>
                                                        }
                                                        {showSmsMessage && smsVideoVisitLink.isFailure &&
                                                            <div className="error-msg">
                                                                <span className="icon-input-clear" />{" "}
                                                                          Link failed to {contactNumber || number} at {currentTime}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            {loadingDemographics || (smsVideoVisitLink && smsVideoVisitLink.isWaiting) &&
                                                <div className="row overlay-loading-container">
                                                    <div className="col-12 align-self-center">
                                                        <MiniSpinner />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="shared-link-modal__section">
                                            <div className="row no-gutters shared-link-group">
                                                <div className="col shared-link-group__icon">
                                                    <span className="svg-email-vv" />
                                                </div>
                                                <div className="col shared-link-group__content">
                                                    <div className="row no-gutters align-items-center shared-link-option">
                                                        <div className="col shared-link-option__field">
                                                            <Email placeholder="Email Address" value={email} name="email" showClearBtn validateOnMount required={false}
                                                                onChange={(e, isEmailValid) => this.setState({ email: e.target.value, isEmailValid, showEmailMessage: false })}
                                                            />
                                                        </div>
                                                        <div className="col shared-link-option__btn">
                                                            <button type="button" className="btn text-btn" onClick={this.emailVideoVisitLink}
                                                                disabled={(!email || !isEmailValid) || (emailVideoVisitLink && emailVideoVisitLink.isWaiting)}
                                                            >SEND</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.emailSent && emailVideoVisitLink &&
                                                <div className="row">
                                                    <div className="col-12">
                                                        {showEmailMessage && emailVideoVisitLink.isSuccess &&
                                                            <div className="success-msg">
                                                                <span className="icon-list-check" />{" "}
                                                                    Link sent to {email} at {currentTime}
                                                            </div>
                                                        }
                                                        {showEmailMessage && emailVideoVisitLink && emailVideoVisitLink.isFailure &&
                                                            <div className="error-msg">
                                                                <span className="icon-input-clear" />{" "}
                                                                    Link failed to {email} at {currentTime}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            {loadingDemographics || (emailVideoVisitLink && emailVideoVisitLink.isWaiting) &&
                                                <div className="row overlay-loading-container">
                                                    <div className="col-12 align-self-center">
                                                        <MiniSpinner />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        smsVideoVisitLink: state.videoVisit.smsVideoVisitLink,
        emailVideoVisitLink: state.videoVisit.emailVideoVisitLink
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPatientDemographics: (externalId, callback) => dispatch({ type: types.PATIENT_DEMOGRAPHICS_START, externalId, callback }),
        sendSms: (room, mobileNumber, participantName, callback) => dispatch({ type: types.SMS_VIDEO_VISIT_LINK, room, mobileNumber, participantName, callback }),
        sendEmail: (room, email, participantName, callback) => dispatch({ type: types.EMAIL_VIDEO_VISIT_LINK, room, email, participantName, callback }),
        getShareLinkHistory: (room) => dispatch({ type: types.VIDEO_VISIT_SHARE_LINK_HISTORY, room }),
        setVideoVisitToastrMsg: (message, successStatus) => dispatch({ type: types.SET_VIDEO_VISIT_TOASTR_MSG, message, successStatus })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareVideoVisitModal));